import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { ICountry } from './country.models';
import { Observable, of } from 'rxjs';
import { SelectListOption } from '@bmw-ds/components';

@Injectable({
  providedIn: 'root',
})
export class CountryOptionsService {
  private readonly http = inject(HttpClient);

  private readonly countriesUrl = `${environment.services.masterdata}/api/countries`;

  public getCountryOptions(): Observable<SelectListOption[]> {
    return this.http.get<ICountry[]>(this.countriesUrl).pipe(
      map((countries) => countries.map((country) => this.mapToOption(country))),
      map((options) =>
        [...options].sort((first, second) => first.id.localeCompare(second.id))
      ),
      shareReplay(1),
      catchError((error) => {
        console.error(
          'Error loading country options',
          error?.error?.message ?? 'Backend error message not available'
        );
        return of([]);
      })
    );
  }

  private mapToOption(country: ICountry): SelectListOption {
    return {
      id: country.id?.toString() ?? '0',
      label: country.tqcCountryCode ?? '',
    };
  }
}
